import { useCallback } from 'react';

import useDateText, { DateTextVariants } from '@/components/DateText/useDateText';
import { useAppSelector } from '@/hooks/redux-hooks';

const hasSpace = / /;
const hasLetter = /[a-zA-Z]/;
const isWithTime = /\dT\d/;

const usePeriodAbsFormatter = () => {
  const dateFormatValue = useAppSelector(state => state.userConfig.userConfig.dateFormat.value);
  const { formatDateString } = useDateText();

  const formatSpaceSeparatedYear = useCallback(
    (periodAbs: string) => {
      if (dateFormatValue.includes('/')) {
        const spaceSplitted = periodAbs.split(' ');
        return `${spaceSplitted[1]}/${spaceSplitted[0]}`;
      }
      if (dateFormatValue.includes('-yy')) {
        const spaceSplitted = periodAbs.split(' ');
        return `${spaceSplitted[1]}-${spaceSplitted[0].slice(2, 4)}`;
      }
      return periodAbs;
    },
    [dateFormatValue]
  );

  const formatPeriodAbs = useCallback(
    (periodAbs: string | undefined) => {
      if (!periodAbs) {
        return '';
      }
      try {
        if (/^\d/.test(periodAbs)) {
          if (isWithTime.test(periodAbs)) {
            return formatDateString(periodAbs, DateTextVariants.WITH_TIME);
          }
          if (periodAbs.includes(' ') && hasLetter.test(periodAbs)) {
            return formatSpaceSeparatedYear(periodAbs);
          }
          if (periodAbs.length > 7) {
            return formatDateString(periodAbs, DateTextVariants.FULL);
          }
          if (periodAbs.length === 4) {
            return periodAbs;
          }
          return formatDateString(periodAbs, DateTextVariants.MONTH_YEAR);
        }
        return periodAbs;
      } catch (error) {
        console.error(error);
        return periodAbs;
      }
    },
    [formatDateString, formatSpaceSeparatedYear]
  );

  return { formatPeriodAbs };
};

export default usePeriodAbsFormatter;
